import React from 'react'
import { useNavigation } from 'react-router-dom'
import { l, NavigationLoader } from '@manychat/manyui'

export const RootLayoutBar = () => {
  const navigation = useNavigation()
  const isLoading = navigation.state === 'loading'

  return isLoading ? <NavigationLoader ariaLabel={l.translate('Page is loading')} /> : null
}
